/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-25 15:11:09
 */
import { defineMessages } from 'react-intl';

const messageObject = {
  checkEnv: '运行环境检测',
  sure: '确认',
  checking: '正在检测中…',
  checkSuccess: '检测完成，未发现异常',
  retest: '重新检测',
  failedTitle: '检测完成，有以下异常项：',
  checkItems: '运行环境检测项 :',
  noPass: '不通过',
  warn: '有风险',
};

export default defineMessages(messageObject);
